# Extracted from BrowseContentView to avoid circular dependencies with DealApplication
DEAL_CONTENT_CONTAINER = '#deal_content'
DEAL_SPACE_MSG_CONTENT = '#deal_space_message_content'

module.exports = BrowseContentHelper =
  getDealsMessageSelector: ->
    $(DEAL_SPACE_MSG_CONTENT)

  getDealsContentSelector: ->
    $(DEAL_CONTENT_CONTAINER)
